import { PublicClientApplication } from "@azure/msal-browser";


const msalConfig = {
  auth: {
    clientId: "129b380d-814a-446d-8079-bc1f77526a36",
    authority: "https://login.microsoftonline.com/534253fc-dfb6-462f-b5ca-cbe81939f5ee",
    redirectUri: window.location.origin // remove the popup window
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

const loginRequest = {
  scopes: [
      "129b380d-814a-446d-8079-bc1f77526a36/.default",
      "openid",
      "profile",
      "email",
      "offline_access"
  ],
  prompt: "select_account"
};

const msalInstance = new PublicClientApplication(msalConfig);

let isInitialized = false;
const initializeMsal = async () => {
  if (!isInitialized) {
    await msalInstance.initialize();
    isInitialized = true;
  }
  return msalInstance;
};

export const signInWithAzureAD = async () => {
  const originalWarn = console.warn;
  console.warn = function(...args) {
    const message = args.join(' ');
    if (message.includes('Cross-Origin-Opener-Policy') || message.includes('window.closed')) {
      return;
    }
    originalWarn.apply(console, args);
  };

  try {
    await initializeMsal();
    
    // First, check if we're returning from a redirect
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
      const account = accounts[0];
      const accountWithTokens = {
        ...account,
        accessToken: account.idToken, // or get token silently
        idToken: account.idToken
      };
      sessionStorage.setItem('currentAccount', JSON.stringify(accountWithTokens));
      return accountWithTokens;
    }

    // If no account found in cache, do interactive login
    try {
      const response = await msalInstance.loginPopup({
        ...loginRequest,
        prompt: 'select_account'  // This ensures account selection every time
      });
      
      console.warn = originalWarn;
      
      if (response && response.account) {
        const accountWithTokens = {
          ...response.account,
          accessToken: response.accessToken,
          idToken: response.idToken
        };
        sessionStorage.setItem('currentAccount', JSON.stringify(accountWithTokens));
        return accountWithTokens;
      }
      return null;
    } catch (popupError) {
      console.warn = originalWarn;
      throw popupError;
    }
  } catch (error) {
    console.warn = originalWarn;
    console.error("Azure AD sign-in error:", error);
    if (error.message?.includes('user_cancelled') || error.errorCode === 'user_cancelled') return null;
    throw error;
  }
};
    

export const handleRedirectResponse = async () => {
  try {
    await initializeMsal();
    const response = await msalInstance.handleRedirectPromise();
    if (response && response.account) {
      const accountWithTokens = {
          ...response.account,
          accessToken: response.accessToken,
          idToken: response.idToken
      };
      sessionStorage.setItem('currentAccount', JSON.stringify(accountWithTokens));
      return accountWithTokens;
    }
    return null;
  } catch (error) {
    console.error("Error handling redirect response:", error);
    return null;
  }
};

export const getCurrentAccount = () => {
  try {
    const storedAccount = sessionStorage.getItem('currentAccount');
    return storedAccount ? JSON.parse(storedAccount) : null;
  } catch (error) {
    return null;
  }
};

export const signOut = async () => {
  try {
    await initializeMsal();
    sessionStorage.removeItem('currentAccount');
    const originalWarn = console.warn;
    console.warn = function(...args) {
      if (args[0] && typeof args[0] === 'string' && args[0].includes('Cross-Origin-Opener-Policy')) {
        return;
      }
      originalWarn.apply(console, args);
    };
    try {
      await msalInstance.logoutPopup();
    } finally {
      console.warn = originalWarn;
    }
    window.dispatchEvent(new CustomEvent('userLogout', { detail: { loggedOut: true } }));
  } catch (error) {
    sessionStorage.removeItem('currentAccount');
    window.dispatchEvent(new CustomEvent('userLogout', { detail: { loggedOut: true } }));
  }
};

export const getUserRole = async () => {
  try {
    const account = getCurrentAccount();
    if (!account) return 'F';
    const baseUrl = window.location.origin;
    const apiResponse = await fetch(`${baseUrl}/api/user-role`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-User-Email': account.username
      }
    });
    if (!apiResponse.ok) return 'F';
    const data = await apiResponse.json();
    return data.role || 'user';
  } catch (error) {
    return 'F';
  }
};

export const getAccessToken = async () => {
    try {
        await initializeMsal();
        const account = getCurrentAccount();
        if (!account) return null;
        const request = {
            scopes: ["129b380d-814a-446d-8079-bc1f77526a36/.default"],
            account: account
        };
        const response = await msalInstance.acquireTokenSilent(request);
        return response.accessToken;
    } catch (error) {
        return null;
    }
};
